import { useState } from "react";
import { toast } from "sonner";
import { Upload, FileText, Trash2, ExternalLink } from "lucide-react";
import { api, API, errMsg } from "@/lib/api";

const KINDS = [
  { kind: "resume", label: "Old resume", hint: "PDF or DOCX (required). AI reads it automatically" },
  { kind: "linkedin", label: "LinkedIn profile PDF", hint: "Save LinkedIn profile as PDF" },
  { kind: "extra", label: "Extra documents", hint: "Optional: offer letters, appraisals, projects" },
];

export default function Uploads({ cid, jobId, files, onChange }) {
  const [busy, setBusy] = useState("");
  const upload = async (kind, file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("kind", kind);
    fd.append("file", file);
    setBusy(kind);
    try {
      await api.post(`/clients/${cid}/files`, fd, { params: jobId ? { job_id: jobId } : {} });
      toast.success(kind === "resume" ? `${file.name} uploaded. The AI is reading it now.` : `${file.name} uploaded`);
      onChange();
    }
    catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(""); }
  };
  const del = async (id) => { await api.delete(`/files/${id}`); onChange(); };
  return (
    <div className="grid grid-cols-3 gap-4">
      {KINDS.map((k) => (
        <div key={k.kind} className="card-surface" data-testid={`upload-card-${k.kind}`}>
          <div className="font-medium">{k.label}</div>
          <div className="text-xs text-muted-foreground mb-3">{k.hint}</div>
          <label className="flex items-center justify-center gap-2 border border-dashed border-slate-700 rounded-lg py-5 text-sm text-slate-400 hover:border-blue-500 hover:text-blue-300 cursor-pointer transition-colors">
            <Upload size={14} /> {busy === k.kind ? "Uploading…" : "Choose file"}
            <input data-testid={`upload-${k.kind}-input`} type="file" className="hidden" accept=".pdf,.docx,.txt"
              onChange={(e) => { upload(k.kind, e.target.files[0]); e.target.value = ""; }} />
          </label>
          <div className="mt-3 space-y-1.5">
            {files.filter((f) => f.kind === k.kind).map((f) => (
              <div key={f.id} className="flex items-center gap-2 text-xs bg-slate-900 rounded-md px-2 py-1.5" data-testid={`file-${f.id}`}>
                <FileText size={12} className="text-blue-400" />
                <span className="truncate flex-1">{f.filename}</span>
                <a href={`${API}/files/${f.id}`} target="_blank" rel="noreferrer" className="text-slate-400 hover:text-slate-200"><ExternalLink size={12} /></a>
                <button data-testid={`delete-file-${f.id}`} onClick={() => del(f.id)} className="text-slate-500 hover:text-rose-400"><Trash2 size={12} /></button>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
